import { Calendar } from 'lucide-react'
import { Tooltip } from 'react-tooltip'
import { SessionManager } from '../../utils'

export default function ActionProspective(props) {

    const { text, route_name, onClick } = props

    var permission = JSON.parse(SessionManager.getSession('permission'))

    return (
        <>
            {permission?.some(val => val.sub_action_name === route_name) &&
                <Calendar size={16} className='action_btn text-secondary me-3'
                    onClick={onClick}
                    data-tooltip-id='prospective'
                    data-tooltip-content={text}
                    data-tooltip-place="bottom"
                />
            }

            <Tooltip id='prospective' className='bg-secondary tooltip_msg' />
        </>
    )
}